import { use } from 'react';
import { callCapabilitiesContext } from './call-capabilities-provider';

export const useCallCapabilities = () => {
  const context = use(callCapabilitiesContext);

  if (!context) {
    throw new Error('useCallCapabilities must be used within a CallPlatformProvider');
  }

  return context;
};
